import React, { createContext, useReducer } from 'react';

import { LogStoreReducer, initialState } from '../reducers/LogStoreReducer';
import {injectIntl} from "react-intl";
import Text from "@amzn/meridian/text";
import {TableRow} from "@amzn/meridian/table";
import {LogStoreAction} from "../action/LogStoreAction";

/**
 * LogStore represents data store for real time logs received for any device type, represented as a Context.
 * rawLogs        : Stores a list of received logs
 * filteredLogs   : Stores a list of filtered logs
 * maxMessageCount: Maximum logs that can be stored
 * filterQuery    : String to filter logs
 * deviceNameQuery: String representing device name to filter logs
 **/
export const LogStoreContext = createContext();

const LogStoreContextProvider = (props) => {
  const [logData, dispatchLog] = useReducer(LogStoreReducer, initialState);

  const filterLogs= () => {
    dispatchLog({
      type: LogStoreAction.FILTER_LOGS
    });
  };

  const setMaxMessageCount = (count) => {
    dispatchLog({
      type: LogStoreAction.SET_MAX_MSG_COUNT,
      data: {
        maxMessageCount: count
      }
    });
  };

  const addLog = (event) => {
    dispatchLog({
      type: LogStoreAction.ADD_LOG,
      data: {
        event: event
      }
    });
    rollupLogs()
  };

  const rollupLogs = () => {
    dispatchLog({
      type: LogStoreAction.ROLLUP_LOG
    });
  };

  const clearLogs = () => {
    dispatchLog({
      type: LogStoreAction.CLEAR_LOGS
    });
  };

  const clearFiltering = () => {
    dispatchLog({
      type: LogStoreAction.CLEAR_FILTERING
    });
  };

  const resetLogStore = () => {
    clearLogs()
    clearFiltering()
  };

  const displayLogs = () => {
    return logData.rawLogs.map((log) => <TableRow highlightOnHover={true} ><Text>{log}</Text></TableRow>);
  };

  const value = {
    logData,
    filterLogs,
    setMaxMessageCount,
    addLog,
    clearLogs,
    displayLogs,
    clearFiltering,
    resetLogStore
  };

  return <LogStoreContext.Provider value={value}>{props.children}</LogStoreContext.Provider>;
};
export default injectIntl(LogStoreContextProvider)



// WEBPACK FOOTER //
// ./src/components/store/context/LogStoreContext.js